import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    components: {
        MuiContainer: {
            defaultProps: {
                maxWidth: 'xl',
            },
            styleOverrides: {
                root: {
                    paddingLeft: '48px !important',
                    paddingRight: '48px !important',
                    '@media (max-width:425px)': {
                        paddingLeft: '15px !important',
                        paddingRight: '15px !important',
                    },
                },
            },
        },
    },
    palette: {
        primary: {
            main: "#FF9500",
        },
    },
    typography: {
        fontFamily: '"Nunito Sans", sans-serif',
        color:'black'
    },
});

export default theme;
